var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxtf-dialog",
    {
      ref: "drawer",
      attrs: {
        "append-to-body": "",
        visible: _vm.visible,
        width: "640px",
        cutline: false,
        "padding-size": "medium",
        "custom-class": "skill_detail-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "eval-detail-wrap" },
        [
          _c(
            "div",
            { staticClass: "standard-size-24 font-medium text-center mb16" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.title || _vm.$t("pc_gwnl_web_capacityAssessmentDetails")
                  ) +
                  "\n    "
              ),
            ]
          ),
          _c("yxt-scrollbar", [
            _c(
              "div",
              { staticClass: "eval-detail-content" },
              [
                _vm.skill.family === 1
                  ? _c(
                      "yxtf-tabs",
                      {
                        staticClass: "gwnl-web-evaldetail-checkbox",
                        model: {
                          value: _vm.activeSkillId,
                          callback: function ($$v) {
                            _vm.activeSkillId = $$v
                          },
                          expression: "activeSkillId",
                        },
                      },
                      _vm._l(_vm.skill[_vm.tabArrKey], function (item) {
                        return _c("yxtf-tab-pane", {
                          key: item.skillId,
                          attrs: { label: item.name, name: item.skillId },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _c("tab-content", {
                  class: { mt24: _vm.skill.family === 2 },
                  attrs: {
                    "active-skill-item": _vm.activeSkillItem,
                    "show-skill-level": _vm.showSkillLevel,
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }